<div *ngIf= "hdr">
Global-HdrGrpId: {{hdr.headerId?hdr.headerId:hdr.id}}
curnt-Id:  {{hdr.id}}

</div>